import { render, staticRenderFns } from "./MFooter.vue?vue&type=template&id=5cb01d78&scoped=true"
import script from "./MFooter.vue?vue&type=script&lang=js"
export * from "./MFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb01d78",
  null
  
)

export default component.exports